<template>
  <Content class="g-main-wrapper">
    <div class="add-cont">
      <div class="cont-hd">
        <span class="goBack" @click="goBack"><i class="el-icon-arrow-left"></i> 返回</span>
        应用管理 > 添加应用
      </div>
      <el-steps :active="active" finish-status="success">
        <el-step title="添加应用"></el-step>
        <el-step title="代码接入"></el-step>
      </el-steps>
      <div class="step step_1" v-if="active === 0">
        <addForm ref="addForms" :addApplicationForm.sync="addApplicationForm" :isEdit="false"></addForm>
        <div class="btns">
          <el-button type="primary" @click="nextAccess">点击下一步代码接入</el-button>
          <el-button type="default" @click="onlyAdd">只添加应用，下次接入</el-button>
        </div>
      </div>
      <div class="step step_2" v-if="active === 1">
        <accessForm ref="accessForms" :accessForm="accessForm"></accessForm>
        <div class="btns">
          <el-button type="primary" @click="done">完成</el-button>
        </div>
      </div>
    </div>
  </Content>
</template>
<script>
import addForm from './components/addForm'
import accessForm from './components/accessForm'
import { buildAggregationApp, buildChannelAggregationApp, passAccessStateByMGameId, passAccessStateByDevGameId } from '@/api/sysmana.model'
export default {
  name: 'applicationDrawer',
  components: {
    addForm,
    accessForm
  },
  data() {
    return {
      drawer: false,
      direction: 'rtl',
      active: 0,
      addApplicationForm: {
        industry: '',
        iconPath: '',
        gameName: '',
        appName: '',
        accessType: '',
        notifyUrl: '',
        gameScale: '',
        platform: 1
      },
      accessForm: {},
      updateForm: {},
      pageName: '',
      mgameId: '',
      devGameId: '',
      row: {},
      disabled: false,
      prevAddForm: {}
    }
  },
  computed: {},
  created() {
    const { name, mgameId, row } = this.$route.query
    this.pageName = name
    this.mgameId = mgameId
    if (row) {
      this.active = 1
      this.disabled = true
      this.accessForm = JSON.parse(row)
      this.accessForm.mgameId = this.accessForm.gameId
    }
  },
  methods: {
    goBack() {
      window.open('/sysmana/application')
    },
    nextAccess() {
      // 点击下一步代码接入
      this.$refs.addForms.$refs.addForm.validate((valid) => {
        if (valid) {
          this.publicSubmit('nextAccess')
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    onlyAdd() {
      // 只添加应用，下次接入
      this.$refs.addForms.$refs.addForm.validate((valid) => {
        if (valid) {
          this.publicSubmit('onlyAdd')
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    publicSubmit(type) {
      const refForm = this.$refs.addForms
      const { industry, iconPath, gameName, appName, accessType, notifyUrl, gameScale, platform } = refForm.addForm
      // 存储第一步填写信息，方便第二步点击上一步回显
      this.prevAddForm = refForm.addForm
      this.prevAddForm.replaceResourceTemplates = refForm.replaceResourceTemplates
      if (this.pageName === 'comprehensive') {
        // 综合应用
        const PtomAggregationVo = {
          industry,
          iconPath: iconPath ? iconPath.split('tmp/')[1] : '',
          gameName,
          appName,
          accessType,
          notifyUrl,
          gameScale,
          platform
        }
        if (PtomAggregationVo.accessType === 2) {
          PtomAggregationVo.notifyUrl = ''
          PtomAggregationVo.gameScale = 0
          PtomAggregationVo.replaceResourceTemplates = []
        } else {
          PtomAggregationVo.replaceResourceTemplates = refForm.getResource()
        }
        buildAggregationApp(PtomAggregationVo).then((data) => {
          if (data) {
            this.accessForm.accessType = PtomAggregationVo.accessType
            this.publicBuild(data, type)
          }
        })
      } else {
        // 聚合应用
        const PtomAggregationVoChannel = {
          gameId: this.mgameId,
          platform,
          appName,
          gameName,
          iconPath: iconPath ? iconPath.split('tmp/')[1] : '',
          gameScale
        }
        buildChannelAggregationApp(PtomAggregationVoChannel).then((data) => {
          if (data) {
            this.publicBuild(data, type)
            this.devGameId = data.openGameId
          }
        })
      }
    },
    publicBuild(data, type) {
      this.accessForm = this.updateForm = data
      if (type === 'nextAccess') {
        this.active = 1
      }
      if (type === 'onlyAdd') {
        window.open('/sysmana/application?name=' + (this.pageName === 'comprehensive' ? 'comprehensive' : 'polymerization'))
      }
    },
    prev(step) {
      if (step === 1) {
        // 点击上一步回显第一步添加的信息
        this.addApplicationForm = this.prevAddForm
      }
      this.active = step === 1 ? 0 : 1
    },
    nextUpdate() {
      this.active = 2
    },
    done() {
      // 完成
      if (this.pageName === 'comprehensive') {
        passAccessStateByMGameId({ gameId: Number(this.updateForm.gameId) || this.accessForm.mgameId }).then((data) => {
          if (data) {
            setTimeout(() => {
              location.href = '/sysmana/application?name=comprehensive'
            }, 500)
          }
        })
      } else {
        passAccessStateByDevGameId({
          gameId: Number(this.updateForm.gameId || this.accessForm.mgameId),
          devGameId: this.devGameId || this.accessForm.devGameId // 正常创建流程传devGameId 或者聚合子应用接入传devGameId
        }).then((data) => {
          if (data) {
            setTimeout(() => {
              location.href = '/sysmana/application?name=polymerization'
            }, 500)
          }
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
:deep(.el-drawer__header > :first-child) {
  font-size: 16px;
}
.g-main-wrapper {
  height: auto;
}
.add-cont {
  .cont-hd {
    padding: 20px 0;
    font-size: 14px;
    border-bottom: 1px solid #ccc;
    font-weight: bold;
    .goBack {
      display: inline-block;
      margin-right: 20px;
      cursor: pointer;
    }
  }
  .el-steps {
    padding: 0 20px;
    margin-top: 20px;
  }
  :deep(.el-step__title) {
    font-size: 14px;
    color: #72767b;
  }
  :deep(.el-step__title.is-process) {
    color: #2d8cf0;
  }
}
.step {
  padding: 20px;
  overflow: hidden;
}
.step_1 .btns {
  margin-top: 50px;
}
.btns {
  margin-top: 20px;
  text-align: center;
}
</style>
